import React from 'react'
import cl from './ContextCard.module.css'
import { Flex, Grid, Tag } from '@chakra-ui/react'

function ContextCard({context, selected, ...props}) {
    const selectedStyle = {
        backgroundColor: 'var(--chakra-colors-orange-50)',
        borderColor: 'var(--chakra-colors-orange-600)',
    }

    return (
        <Grid
            className={cl.container}
            style={selected ? selectedStyle : {}}
            {...props}
        >
            <Tag colorScheme='orange' mr='auto'>
                {context.role.title}
            </Tag>
            <Flex gap='6px' flexWrap='wrap'>
                {context.subjects.map(subject => (
                    <Tag
                        size='sm'
                        colorScheme='orange'
                        variant='outline'
                        key={`modal-context-${context.id}-subject-${subject.id}`}
                    >
                        {subject.title}
                    </Tag>
                ))}
            </Flex>
            <Flex gap='6px' flexWrap='wrap'>
                {context.class_years.map(class_year => (
                    <Tag
                        size='sm'
                        colorScheme='orange'
                        variant='outline'
                        key={`modal-context-${context.id}-classyear-${class_year.id}`}
                    >
                        {class_year.title}
                    </Tag>
                ))}
            </Flex>
        </Grid>
    )
}

export default ContextCard
